<template>
  <div
    class="curation-editor"
    id="jps-curation-editor"
    :class="editorClass"
    v-if="editstate && editstate.curation"
  >
    <Component
      class="curation-editor-header"
      :is="headerComponent"
      :editstate="editstate"
    />
    <slot name="extra-header" />
    <CurationEditorRenderer
      class="jps-curation-editor-parts"
      :editstate="editstate"
      :def="{ parts: editstate.curation.parts }"
    />
    <slot name="extra-footer" />
    <Component
      class="curation-editor-footer"
      :is="footerComponent"
      :editstate="editstate"
    />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  editstate: CurationEditState
}
const props = withDefaults(defineProps<Props>(), {})

const editorClass = computed(() => {
  return 'editor-mode-' + props.editstate.mode
})

const headerComponentMap = {
  'GALLERY': defineAsyncComponent(() => import('./header/CurationEditorHeaderGallery.vue')),
  'SUBPAGE': defineAsyncComponent(() => import('./header/CurationEditorHeaderSubpage.vue')),
  'PAGE': defineAsyncComponent(() => import('./header/CurationEditorHeaderPage.vue')),
  'NOTE': defineAsyncComponent(() => import('./header/CurationEditorHeaderNote.vue')),
}
const headerComponent = computed(() => {
  if (props.editstate && props.editstate.curation) {
    return headerComponentMap[props.editstate.curation.curationType] ?
      headerComponentMap[props.editstate.curation.curationType]
      : null
  }
  return null
})

const footerComponentMap = {
  'GALLERY': defineAsyncComponent(() => import('./footer/CurationEditorFooterGallery.vue')),
}
const footerComponent = computed(() => {
  if (props.editstate && props.editstate.curation) {
    if (props.editstate.page === 'mygallery') return null
    return footerComponentMap[props.editstate.curation.curationType] ?
      footerComponentMap[props.editstate.curation.curationType]
      : null
  }
  return null
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-editor {
  background: $jps-gray-50;
  margin-bottom: 2rem;
  border-radius: $global-radius-large;
  @include is-mobile() {
    margin-right: 0;
  }
}
</style>
